import { Button } from "@/components/ui/button";
import { Facebook, Instagram, Twitter } from "lucide-react";

interface DevotionalShareProps {
  title: string;
  date: string;
}

export const DevotionalShare = ({ title, date }: DevotionalShareProps) => {
  const baseUrl = window.location.origin;
  const devotionalUrl = `${baseUrl}/devotional/${date}`;
  const shareText = `Check out today's devotional: ${title}`;

  const handleShare = (platform: 'facebook' | 'twitter' | 'instagram') => {
    let shareUrl = '';

    switch (platform) {
      case 'facebook':
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(devotionalUrl)}`;
        break;
      case 'twitter':
        shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(shareText)}&url=${encodeURIComponent(devotionalUrl)}`;
        break;
      case 'instagram':
        // Instagram doesn't have a direct share URL, so we'll copy the link to clipboard
        navigator.clipboard.writeText(`${shareText}\n${devotionalUrl}`);
        return;
    }

    if (shareUrl) {
      window.open(shareUrl, '_blank', 'width=600,height=400');
    }
  };

  return (
    <div className="flex justify-center space-x-4 my-6">
      <Button
        variant="outline"
        size="icon"
        onClick={() => handleShare('facebook')}
        className="hover:text-blue-600"
        title="Share on Facebook"
      >
        <Facebook className="h-5 w-5" />
      </Button>
      <Button
        variant="outline"
        size="icon"
        onClick={() => handleShare('twitter')}
        className="hover:text-sky-500"
        title="Share on Twitter"
      >
        <Twitter className="h-5 w-5" />
      </Button>
      <Button
        variant="outline"
        size="icon"
        onClick={() => handleShare('instagram')}
        className="hover:text-pink-600"
        title="Copy link for Instagram"
      >
        <Instagram className="h-5 w-5" />
      </Button>
    </div>
  );
};